import { Box, SimpleGrid, useColorModeValue } from "@chakra-ui/react";
import FormTemplate from "./components/Form";
import TemplateTable from "./components/Table";
import useTemplateOrder from "./hooks/useTemplateOrder";
import { ConditionalRenderer } from "views/admin/components/ConditionalRenderer";
import { SimpleConditionalFrame } from "views/admin/components/SimpleConditionalFrame";

const ItemTemplateScreen = () => {
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  const {
    add,
    templateList,
    edit,
    showDeleteModal,
    showDelete,
    cancelRef,
    closeDelete,
    deletar,
    changeNome,
    show,
    accountSelected,
    error,
    errorMsg,
    errorTitle,
    loading,
    nome,
    closeError,
    showModal,
    showItemModal,
    itens,
    nomeRef,
    showItem,
    usuario,
    changeItem,
    removeItem,
    saveCategory,
    enableDrag,
    isDragable,
    reorder,
    save,
    condicaoPagamentos,
    addRowItem,
    deleteRow,
    editRow,
    itemList
  } = useTemplateOrder();
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>

      <ConditionalRenderer
        conditions={[
          {
            condition: show,
            component: (
              <SimpleConditionalFrame
                backClick={() => showModal(false)}
                title={accountSelected !== null ? "Editar Template" : "Novo Template"}
              >
                <FormTemplate
                  textColor={textColor}
                  brandStars={brandStars}
                  borderColor={borderColor}
                  changeNome={changeNome}
                  itens={itens}
                  show={show}
                  showModal={showModal}
                  accountSelected={accountSelected}
                  error={error}
                  nome={nome}
                  loading={loading}
                  save={save}
                  changeItem={changeItem}
                  deleteRow={null}
                  addRow={null}
                  errorTitle={errorTitle}
                  errorMsg={errorMsg}
                  cancelRef={cancelRef}
                  closeError={closeError}
                  showItemModal={showItemModal}
                  nomeRef={nomeRef}
                  saveItem={saveCategory}
                  showCategory={showItem}
                  drag={enableDrag}
                  isDragable={isDragable}
                  removeItem={removeItem}
                  reorder={reorder}
                  condicaoPagamento={condicaoPagamentos}
                  addRowItem={addRowItem}
                  deleteRow1={deleteRow}
                  editRow={editRow}
                  itemList={itemList}
                />
              </SimpleConditionalFrame>
            )
          }
        ]}
        fallback={(
          <SimpleGrid
            mb="20px"
            columns={{ sm: 1, md: 1 }}
            spacing={{ base: "20px", xl: "20px" }}
          >
            <TemplateTable
              add={add}
              edit={edit}
              list={templateList}
              deletar={showDeleteModal}
              showDelete={showDelete}
              cancelRef={cancelRef}
              closeDelete={closeDelete}
              remove={deletar}
            />
          </SimpleGrid>
        )}
      />

      <SimpleGrid
        mb="20px"
        columns={{ sm: 1, md: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
      >


      </SimpleGrid>
    </Box>
  );
};
export default ItemTemplateScreen;
